import script from "./ViewBudgetsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBudgetsPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewBudgetsPage.vue?vue&type=style&index=0&id=39ef91fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ef91fc"]])

export default __exports__